const ErrorIcon = ({ color = "#E53E3E", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth={2} />
      <path
        d="M9.5 9.5L14.5 14.5"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M14.5 9.5L9.5 14.5"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default ErrorIcon;